/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { CreatorsAnchors } from '../../../../store/ducks/anchors';
import { getPermissions } from '../../../../services/auth';
import api from '../../../../services/api';
import {
  consultarPerfisErpAtivos,
  atualizar,
  consultarLojasBluesoft,
  csvToTipoDuplicataKeys,
  tipoDuplicataKeysToCsv,
  lojasKeysToArray,
  arrayToLojasKeysCsv,
} from '../../../../services/ancorasImportacoesTitulosService';

import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import Loading from '../../../../components/Loading';
import Form, { toTimeInput, toTimeSpanPayload } from '../Form';
import useStyles from '../style';

function Edit({ id }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [perfis, setPerfis] = useState([]);
  const [vinculoOriginal, setVinculoOriginal] = useState(null);
  const [form, setForm] = useState({});
  const [todasLojas, setTodasLojas] = useState(true);
  const [lojasKeysArr, setLojasKeysArr] = useState([]);
  const [lojasCarregadas, setLojasCarregadas] = useState([]);
  const [carregandoLojas, setCarregandoLojas] = useState(false);

  const carregar = async () => {
    try {
      const [respVinc, listaPerfis] = await Promise.all([
        api.get(`AncorasImportacoesTitulosApisErps/ConsultarId?id=${id}`),
        consultarPerfisErpAtivos(),
      ]);
      const v = respVinc?.data?.resposta;
      if (!v || !v.ancoraImportacaoTituloApiErpId) {
        toast.error('Integracao nao encontrada');
        history.push('/app');
        return;
      }
      setVinculoOriginal(v);
      setPerfis(listaPerfis);
      // Nome da ancora no titulo (subanchor)
      try {
        const respAncora = await api.get(`Ancoras/ConsultarId?id=${v.ancoraId}`);
        const nome = respAncora?.data?.resposta?.nomeFantasia;
        if (nome) dispatch(CreatorsAnchors.changeLastAnchor(nome));
      } catch (_) {}
      const arr = lojasKeysToArray(v.lojasKeys);
      setLojasKeysArr(arr);
      setTodasLojas(arr.length === 0);
      setForm({
        apelido: v.apelido || '',
        importacaoTituloApiErpId: v.importacaoTituloApiErpId || 0,
        clientId: v.clientId || '', // vem "" pelo mask do backend
        clientSecret: '', // vazio = manter atual
        tenantSlug: v.tenantSlug || '',
        tipoDuplicataKeys: csvToTipoDuplicataKeys(v.tipoDuplicataKeys),
        horarioGeracaoFull: toTimeInput(v.horarioGeracaoFull),
        horarioGeracaoComplementar: toTimeInput(v.horarioGeracaoComplementar),
        intervaloMinimoMinutos:
          v.intervaloMinimoMinutos !== null && v.intervaloMinimoMinutos !== undefined
            ? v.intervaloMinimoMinutos
            : '',
        status: v.status || 'Ativo',
        enviarBaixaTitulosAntecipados: !!v.enviarBaixaTitulosAntecipados,
        dataUltimaGeracaoFull: v.dataUltimaGeracaoFull || null,
        dataUltimaGeracaoComplementar: v.dataUltimaGeracaoComplementar || null,
        dataAtualizacao: v.dataAtualizacao,
      });
    } catch (e) {
      toast.error('Falha ao carregar integracao');
    }
    setLoading(false);
  };

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-integracoes-titulos'));
    const ok = getPermissions({ moduloId: 58872, permissao: 'Alterar' });
    if (ok) carregar();
    else history.push('/app');
  }, []);

  const handleFieldChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleToggleTodas = (event) => {
    const checked = event.target.checked;
    setTodasLojas(checked);
    if (checked) setLojasKeysArr([]);
  };

  const handleCarregarLojas = async () => {
    setCarregandoLojas(true);
    try {
      const lista = await consultarLojasBluesoft(id);
      if (!Array.isArray(lista) || lista.length === 0) {
        toast.info('Nenhuma loja encontrada na Bluesoft para este vinculo.');
        setLojasCarregadas([]);
      } else {
        setLojasCarregadas(lista);
      }
    } catch (err) {
      const status = err?.response?.status;
      const msg = err?.response?.data?.resposta?.[0]?.message;
      if (status && status >= 400 && status < 500 && msg) toast.error(msg);
      else toast.error('Falha ao consultar lojas na Bluesoft. Verifique as credenciais.');
    }
    setCarregandoLojas(false);
  };

  const validate = () => {
    if (!form.apelido || !form.apelido.trim()) return 'Informe o apelido';
    if (!Number(form.importacaoTituloApiErpId)) return 'Selecione o perfil ERP';
    // clientId/clientSecret vazios sao permitidos no update — backend preserva
    if (!Array.isArray(form.tipoDuplicataKeys) || form.tipoDuplicataKeys.length === 0)
      return 'Selecione ao menos um tipo de duplicata';
    if (!todasLojas && lojasKeysArr.length === 0)
      return "Selecione ao menos uma loja ou marque 'Todas as lojas'";
    return null;
  };

  const handleSubmit = async () => {
    const err = validate();
    if (err) {
      toast.error(err);
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ancoraImportacaoTituloApiErpId: vinculoOriginal.ancoraImportacaoTituloApiErpId,
        ancoraId: vinculoOriginal.ancoraId,
        apelido: form.apelido.trim(),
        importacaoTituloApiErpId: Number(form.importacaoTituloApiErpId),
        clientId: form.clientId ? form.clientId.trim() : '',
        tenantSlug: form.tenantSlug ? form.tenantSlug.trim() : null,
        tipoDuplicataKeys: tipoDuplicataKeysToCsv(form.tipoDuplicataKeys),
        lojasKeys: todasLojas ? '' : arrayToLojasKeysCsv(lojasKeysArr),
        horarioGeracaoFull: toTimeSpanPayload(form.horarioGeracaoFull),
        horarioGeracaoComplementar: toTimeSpanPayload(form.horarioGeracaoComplementar),
        intervaloMinimoMinutos:
          form.intervaloMinimoMinutos === '' ? null : Number(form.intervaloMinimoMinutos),
        status: form.status,
        enviarBaixaTitulosAntecipados: !!form.enviarBaixaTitulosAntecipados,
        dataAtualizacao: form.dataAtualizacao,
      };
      // ClientSecret preenchido = re-criptografa; vazio = mantem
      if (form.clientSecret && form.clientSecret.trim()) {
        payload.clientSecret = form.clientSecret;
      }
      const resp = await atualizar(payload);
      const dataAtu = resp?.data?.resposta?.dataAtualizacao;
      setForm((prev) => ({ ...prev, dataAtualizacao: dataAtu || prev.dataAtualizacao }));
      toast.success('Integracao atualizada com sucesso!');
    } catch (e) {
      // erro global ja tratado
    }
    setSaving(false);
  };

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title="Editando integracao ERP da rede: "
        loading={loading || saving}
        back={vinculoOriginal ? `/app/editar-ancora/${vinculoOriginal.ancoraId}` : '/app'}
        submit={handleSubmit}
        submitText="Atualizar"
        subanchor
      />
      <div className={classes.content}>
        <div className={classes.rootForm} style={{ marginLeft: '5%', width: '90%' }}>
          {loading ? (
            <Loading />
          ) : (
            <div>
              <Form
                mode="edit"
                form={form}
                onFieldChange={handleFieldChange}
                perfis={perfis}
                todasLojas={todasLojas}
                onToggleTodasLojas={handleToggleTodas}
                lojasKeysArr={lojasKeysArr}
                onChangeLojas={(e) => setLojasKeysArr(e.target.value)}
                lojasCarregadas={lojasCarregadas}
                carregandoLojas={carregandoLojas}
                onCarregarLojas={handleCarregarLojas}
              />
              <div className={classes.divButton}>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className={classes.button}
                  disabled={saving}
                >
                  Atualizar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Edit;
